var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    { class: ["z-figure", { "z-figure--video": this.video }] },
    [
      _c(
        "div",
        { staticClass: "z-figure__container" },
        [
          _vm.image
            ? _c("z-image", {
                staticClass: "z-figure__image",
                attrs: { background: "", src: _vm.image },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("video"),
          _vm._v(" "),
          _vm.caption
            ? _c("figcaption", { staticClass: "z-figure__caption" }, [
                _c("span", { domProps: { innerHTML: _vm._s(_vm.caption) } }),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }